module.exports = __webpack_public_path__ + "static/media/faq_3.6970d08a.png";